export const ERROR_MESSAGE = {
    USER_ALREADY_EXISTS: 'USER_ALREADY_EXISTS',
    PAYMENT_PROVIDER_ERROR: 'PAYMENT_PROVIDER_ERROR'
}